module.exports = __webpack_public_path__ + "static/img/heynanaco-qrcode.8eddb2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/heynanaco-qrcode.png
// module id = 49uq
// module chunks = 0